import React from "react";
import { useFormikContext } from "formik";
import { Box, Typography } from "@mui/material";

import { IFormikValues } from "../EditWindow";
import { IHobby } from "store/types/user/social";

interface IComponentProps {
  componentName: string;
  componentArrayValue: IHobby[];
}

export const Chips: React.FC<IComponentProps> = ({ componentName, componentArrayValue }) => {
  const { values, setFieldValue } = useFormikContext<IFormikValues>();

  const checkSelected = (item: IHobby) => {
    return values[componentName].some((obj: { id: number; title: string }) => obj.id === item.id);
  };

  const chipsClickHandler = (item: IHobby) => {
    if (checkSelected(item)) {
      setFieldValue(
        componentName,
        values[componentName].filter((obj: { id: number; title: string }) => obj.id !== item.id)
      );
      return;
    } else {
      setFieldValue(componentName, [...values[componentName], { id: item.id, title: item.title }]);
    }
  };

  return (
    <div style={{ width: "100%", borderRadius: "8px", backgroundColor: "#fff" }}>
      <Box sx={{ padding: "32px", display: "flex", flexDirection: "row", flexWrap: "wrap", gap: "10px" }}>
        {componentArrayValue.map((item, index) => (
          <Typography
            onClick={() => chipsClickHandler(item)}
            sx={{
              ...(checkSelected(item)
                ? {
                    backgroundColor: "#26a6ae"
                  }
                : {
                    backgroundColor: "#5d7782"
                  }),
              cursor: "pointer",
              padding: "5px 16px",
              fontSize: "14px",
              color: "#fff",
              borderRadius: "15px"
            }}
            key={index}
          >
            {item.title}
          </Typography>
        ))}
      </Box>
    </div>
  );
};
